var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProtected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.982 0.555211L10.4405 1.16271C8.1455 3.73971 4.9595 4.95621 1.1585 5.41971L0.5 5.49921V6.16371C0.5 10.0337 1.319 13.7882 3.014 16.8662C4.709 19.9442 7.31 22.3457 10.7855 23.3822L11.009 23.4497L11.231 23.3732C17.948 21.2027 21.5 14.1317 21.5 6.16371V5.56671L20.9165 5.42871C17.219 4.57671 13.8095 3.54171 11.5445 1.14921L10.982 0.553711V0.555211ZM11.018 2.55021C13.4465 4.81821 16.6355 5.91021 19.9385 6.69921C19.781 13.8707 16.643 19.8527 10.994 21.8222C8.0525 20.8697 5.831 18.8672 4.3295 16.1417C2.8655 13.4867 2.1395 10.1687 2.0615 6.71871C5.534 6.19221 8.6345 4.94871 11.0165 2.55021H11.018ZM15.005 8.97171L9.5345 13.7612L7.0295 11.2592L5.969 12.3197L9.464 15.8147L15.995 10.1012L15.005 8.97171Z",
    fill: "#4EAF51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtected);
export default __webpack_public_path__ + "static/media/protected.c79857676b4045371a557dfe28b56859.svg";
export { ForwardRef as ReactComponent };